import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { BroadcastService } from '../broadcast/broadcast.service';
import { CommonEvents } from '../../enums/common-events.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { PingService } from '../ping/ping.service';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ConnectionService implements OnDestroy {
    public get isCASLinkConnectionAlive(): boolean {
        return this.hasInternetAccess && this.hasNetworkConnection;
    }

    private hasInternetAccess = false;
    private hasNetworkConnection = window.navigator.onLine;

    private offlineSubscription: Subscription;
    private onlineSubscription: Subscription;
    private routeChangePing: Subscription;

    constructor(
        private broadcastService: BroadcastService,
        private pingService: PingService,
        router: Router
    ) {
        this.checkNetworkState();

        this.routeChangePing = router.events.subscribe((event)=>{
            if (event instanceof NavigationEnd)
            {
                this.ping();
            }
        });
    }

    /**
     * This service should be always present throughout lifetime of the app,
     * but there is still risk of memory leaks
     */
    public ngOnDestroy() {
        this.offlineSubscription.unsubscribe();
        this.onlineSubscription.unsubscribe();
        this.routeChangePing.unsubscribe();
    }

    private checkNetworkState() {
        this.onlineSubscription = fromEvent(window, 'online')
            .subscribe(() => {
                this.hasNetworkConnection = true;
                this.broadcastChange();
            });

        this.offlineSubscription = fromEvent(window, 'offline')
            .subscribe(() => {
                this.hasNetworkConnection = false;
                this.broadcastChange();
            });
    }

    /**
     * Checks if host is available assuming the host is not on local network
     */
    private ping() {
        this.pingService.ping().subscribe(_ => {
            this.hasInternetAccess = true;
            this.broadcastChange();
        }, (error: HttpErrorResponse) => {
        });
    }

    private broadcastChange() {
        this.broadcastService.broadcast(CommonEvents.ConnectionStatus, this.isCASLinkConnectionAlive);
    }
}
